import React from 'react';
import PropTypes from 'prop-types';
import icon from '../../components/Login/Icons/ParklandLogo.png';
import './Header.scss';

/**
 * Header component
 * @class Header
 * @extends {Component}
 */

class Header extends React.Component {
  static propTypes = {
    /** Title show in the Header */
    headerTitle: PropTypes.string,
  };

  static defaultProps = { headerTitle: '', };

  render() {
    const { headerTitle, } = this.props;

    return (
      <div className='Custom-Header-Box'>
        <img className='Custom-Header-Icon' src={icon} alt='icon' />
        {headerTitle &&
          <div className='Custom-Header-Text'>
            <span>{headerTitle}</span>
          </div>
        }
      </div>
    );
  }
}

export default Header;
